var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.italic)?_c('i',[_vm._v(_vm._s(_vm.text))]):_c('p',[_vm._v(" "+_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }